import { render, staticRenderFns } from "./ViewFileModal.vue?vue&type=template&id=380d6d00&scoped=true"
import script from "./ViewFileModal.vue?vue&type=script&lang=js"
export * from "./ViewFileModal.vue?vue&type=script&lang=js"
import style0 from "./ViewFileModal.vue?vue&type=style&index=0&id=380d6d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d6d00",
  null
  
)

export default component.exports